import React, {
  useContext, lazy, useEffect, useState, useCallback,
} from 'react';
import propTypes from 'prop-types';
import {
  Route,
  Redirect,
  Switch,
  withRouter,
} from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { AppContext } from '@/redux/store';
import RenderBox from '@/3DEngine/components/renderBox';
// import callEngine from '@/3DEngine/callEngine/index';
import Loading from '@/components/Loading/loading';
import AidDialog from '@/components/aidDialog/AidDialog';
import ArcButton from '@/components/arcButton';
import NavBar from '@/components/NavBar/navBar';
import { PLATFORM, storeLeadsInfo } from '@/utils/util';
import { getPlatform } from '@/utils/rules/const';
import gioTrack from '@/utils/track';
import { jumpNewCSC, goHome } from '@/adaptPlatform/index';
import SideBar from '@/components/SideBar/sideBar.tsx';
import gestureTip from '@/assets/gesture.gif';
// import ArrowDownImg from '../../assets/arrow_down_black.svg';

import sketchLIR from '@/assets/sketch/LIR.png';
import sketchLIL from '@/assets/sketch/LIL.png';
import sketchLL from '@/assets/sketch/LL.png';
import sketchLN from '@/assets/sketch/LN.png';

import sketchII from '@/assets/sketch/II.png';
import sketchIN from '@/assets/sketch/IN.png';

import sketchUH from '@/assets/sketch/UH.png';
import sketchUIR from '@/assets/sketch/UIR.png';
import sketchUIM from '@/assets/sketch/UIM.png';
import sketchUIL from '@/assets/sketch/UIL.png';
import sketchULR from '@/assets/sketch/ULR.png';
import sketchULL from '@/assets/sketch/ULL.png';
import sketchUN from '@/assets/sketch/UN.png';

import sketchHH from '@/assets/sketch/HH.png';
import sketchHIR from '@/assets/sketch/HIR.png';
import sketchHIL from '@/assets/sketch/HIL.png';
import sketchHN from '@/assets/sketch/HN.png';

import { useWallList, useFloorList } from '@/hooks/homePagehooks/useList';
import callEngine from '@/3DEngine/callEngine';
import Home from '@/pages/home/Home';
import group from '../../assets/Group.png';
import style from './homePage.module.scss';


const DoorPlank = lazy(() => import('../doorPlank/doorPlank'));
const Storage = lazy(() => import('../storage/storage'));
const Mesa = lazy(() => import('../mesa/mesa'));
const Offer = lazy(() => import('../offer/offer'));

function HomePage(props) {
  const { location } = props;
  const { state, pathname } = location;
  const { t } = useTranslation();
  const { initState, dispatch } = useContext(AppContext);
  const [appWidth, setAppWidth] = useState(0);
  const [appHeight, setAppHeight] = useState(260);
  const [sketchHeight, setSketchHeight] = useState(250);
  const [contentHeight, setContentHeight] = useState(0);
  // const [exitWidth, setExitWidth] = useState('2.5rem');
  const [visible, setVisible] = useState(false);
  // const [lineDisplay, setlineDisplay] = useState('block');
  const [imgWidht, setimgWidth] = useState(0);// 手势提示图片宽度
  const [imgHeight, setimgHeight] = useState(0);// 手势提示图片高度
  const [gestureX, setXestureX] = useState(); // 手势图中心点坐标x
  const [gestureY, setXestureY] = useState();// 手势图中心点坐标y
  const a = 4.887640449438202;// 手势图宽高比系数
  const [isHome, setisHome] = useState(false); // 是否在尺寸页面
  const [isPackOffer, setisPackOffer] = useState(false); // 是否在packOffer
  const [isFirstintoHome, setisFirstintoHome] = useState(true); // 是否第一次进入尺寸页面
  const { wallList } = useWallList();
  const { floorList } = useFloorList();

  const container = React.createRef();

  // 为元素添加事件监听
  const preventDefault = (flag) => {
    if (flag) {
      document.querySelector('body').style.overflow = 'hidden';
    } else {
      document.querySelector('body').style.overflow = 'auto';
    }
  };

  const handleCancel = () => {
    setVisible(false);
    preventDefault(false);
    // setExitWidth('2.5rem');
  };
  const handleOk = () => {
    setVisible(false);
    preventDefault(false);
  };
  // 联系设计师-> 联系客服
  const contactDesigner = () => {
    handleCancel();
    sessionStorage.setItem('clickToMakeAppointment', true);
    jumpNewCSC({
      autoText: `${t('csc_text.size_help')}`,
    });
    const {
      getStepDetail, houseState, serviceMark, capitalRetention,
    } = initState;
    const { size, totalCost } = getStepDetail;
    const { bottom, top } = size;
    gioTrack('submitAppointment', {
      page_var: window.location.href, // 页面URL
      pageSource_var: getPlatform[localStorage.getItem('currentPlatform')], // 页面来源
      designCode_var: initState.designCode, // 设计代码
      size_var: bottom.len1 + bottom.len2 + bottom.len3 + top.len1 + top.len2, // 尺寸
      payAmount_var: totalCost,
      roomStatus_var: houseState, // 房屋状态
      reserveStoreID_var: serviceMark, // 用户预约的门店号
      ifSuccess_var: capitalRetention, // Y/N
    });
  };
  // ikeacn 点击LOGO返回首页    app直接退出返回首页   smp
  const handleClose = (State) => {
    handleCancel();
    // window.location.href = 'https://store-companion.ikea.cn/kitchen?channel=EC%20channel&cl_sr=KitchenTool_Back';
    goHome(State);
  };

  const targetRouter = () => {
    if (state) {
      return (
        <Switch>
          <Route exact path="/home/homepage" component={Home} />
          <Route path="/home/doorPlank" component={DoorPlank} />
          <Route path="/home/storage" component={Storage} />
          <Route path="/home/mesa" component={Mesa} />
          <Route path="/home/offer" component={Offer} />
          <Route
            path="/home/packOffer/:code"
            render={() => {
              storeLeadsInfo();
              return (
                <Redirect to={{
                  pathname: `/home/packOffer/${state}`,
                  state,
                }}
                />
              );
            }}
          />
          <Route
            path="/home/designList/:code"
            render={() => {
              storeLeadsInfo();
              return (
                <Redirect to={{
                  pathname: `/home/designList/${state}`,
                  state,
                }}
                />
              );
            }}
          />
        </Switch>
      );
    }
    if ((pathname.split('/packOffer/')[1] && pathname.split('/packOffer/')[1].length === 6)
    || (pathname.split('/designList/')[1] && pathname.split('/designList/')[1].length === 6)) {
      return (
        <Switch>
          <Route exact path="/home/homepage" component={Home} />
          <Route path="/home/doorPlank" component={DoorPlank} />
          <Route path="/home/storage" component={Storage} />
          <Route path="/home/mesa" component={Mesa} />
          <Route path="/home/offer" component={Offer} />
          <Route
            path="/home/packOffer"
            render={() => {
              storeLeadsInfo();
              return (
                <Redirect to={{
                  pathname: `/home/packOffer/${pathname.split('/packOffer/')[1]}`,
                  state: `${pathname.split('/packOffer/')[1]}`,
                }}
                />
              );
            }}
          />
          <Route
            path="/home/designList"
            render={() => {
              storeLeadsInfo();
              return (
                <Redirect to={{
                  pathname: `/home/designList/${pathname.split('/designList/')[1]}`,
                  state: `${pathname.split('/designList/')[1]}`,
                }}
                />
              );
            }}
          />
        </Switch>
      );
    }
    if (pathname.substring(pathname.length - 6) === 'change') {
      return (
        <Switch>
          <Route exact path="/home/homepage/stepone/change" component={Home} />
          <Route path="/home/homepage/steptwo/change" component={Home} />
          <Route path="/home/homepage/stepthree/change" component={Home} />
          <Route path="/home/doorPlank/change" component={DoorPlank} />
          <Route path="/home/storage/change" component={Storage} />
          <Route path="/home/mesa/change" component={Mesa} />
          <Route path="/home/offer" component={Offer} />
        </Switch>
      );
    }
    return (
      <>
        <Route path="/home/homepage" component={Home} />
        {/* <Route path="/home/homepage/steptwo" component={Home} />
        <Route path="/home/homepage/stepthree" component={Home} /> */}
        <Route path="/home/doorPlank" component={DoorPlank} />
        <Route path="/home/storage" component={Storage} />
        <Route path="/home/mesa" component={Mesa} />
        <Route path="/home/offer" component={Offer} />
        <Route
          path="/home"
          exact
          render={() => <Redirect to="/home/homepage/stepone" />}
        />
      </>

    );
  };
  useEffect(() => { // 在APP端修复底下空白
    setTimeout(() => {
      document.getElementById('content-container').style.transition = 'none';
      if (localStorage.getItem('currentPlatform') === 'app') {
        dispatch({ type: 'sizeSign', payload: false });
        document.getElementById('content-container').style.transition = 'all 500ms';
      }
    }, 200);
  }, [initState.sizeSign]);

  useEffect(() => {
    if (localStorage.getItem('currentPlatform') === 'smp') {
      document.title = t('mcc.kitchen_quotation_tool');
    }

    setAppWidth(document.documentElement.clientWidth);
    document.onclick = () => { // 点击任何关闭墙面地面选择栏
      dispatch({ type: 'filterColor', payload: false }); // 是否展示墙面地面选择栏
      dispatch({ type: 'istip', payload: false }); // 是否展示手势图示
    };
    // 初始化计算高度
    const height = (250 * document.getElementById('root').offsetWidth) / 375;
    setAppHeight(height);
    const sketchHeight = (250 * document.getElementById('root').offsetWidth) / 375;
    setSketchHeight(sketchHeight);
    setContentHeight(
      window.innerHeight
        - document.getElementById('bars-container').offsetHeight
        - height - 1,
    );
  }, []);

  useEffect(() => {
    let time;
    // 当第一次3D init后才能显示手势提示，并且是用户首次进入才显示
    // if (initState.is3DFirstInit && localStorage.getItem('new') === 'true') {
    if (initState.is3DFirstInit && pathname.includes('steptwo')) {
      // 计算手势提示宽高
      callEngine(initState.engine3D, 'guideGif', undefined, initState.jsonTemplate).then((data) => {
        setimgWidth(data.width);
        setimgHeight(data.width / a);
        setXestureX(data.x);
        setXestureY(data.y);
      });
      // dispatch({ type: 'istip', payload: localStorage.getItem('new') === 'true' }); // 是否展示手势图示
      dispatch({ type: 'istip', payload: true }); // 是否展示手势图示
      time = setTimeout(() => {
        dispatch({ type: 'istip', payload: false }); // 6秒后关闭
      }, 6000);
    }

    return () => {
      clearTimeout(time);
    };
  }, [initState.is3DFirstInit]);

  useEffect(() => { // 根据路由是否启动触摸事件、line条的显示
    setisPackOffer(false);
    const pathPartList = pathname.split('/');
    // offer、packOffer、payService页面没有line条，且需要对contentHeight做特殊处理
    if (pathPartList.some((item) => item === 'offer' || item === 'packOffer' || item === 'designList')) {
      if (PLATFORM() === 'smp') {
        setContentHeight(window.innerHeight - document.getElementById('bars-container').offsetHeight);
      } else {
        // 注意这边不是document.getElementById('bars-container').offsetHeight去获取，
        // 而是写了61原因就是当从payService页面或者其他页面进入到offer或packOffer页面，此时页面UI重新渲染还无法拿到高度值
        setContentHeight(window.innerHeight - 61);
      }
      // setlineDisplay('none');

      if (pathPartList.some((item) => item === 'packOffer' || item === 'designList')) {
        setisPackOffer(true);
      }
    } else if (pathPartList.some((item) => item === 'payService' || item === 'assembly')) {
      setContentHeight(0);
      // setlineDisplay('none');
    } else {
      // 当非前面3个页面时也就是前面四步骤的页面需要默认设置3D显示区显示最大
      // eslint-disable-next-line no-lonely-if
      if (contentHeight && document.getElementById('bars-container').offsetHeight) {
        // 初始化计算高度后，前四步不需要 setContentHeight，offer 页 setContentHeight，此时返回到任一步骤时需要重新 setContentHeight
        // 此外，在非“选择柜型”页面刷新时，会重定向，初始化计算高度中无法获取 offsetHeight，此时 setContentHeight 了一个错误值，需要重新 setContentHeight
        setContentHeight(
          window.innerHeight
          - document.getElementById('bars-container').offsetHeight
          - appHeight - 1,
        );
      } else if (pathname.includes('change')) {
        // 直接进入packOffer页面，无法获取 offsetHeight，返回修改时没有步骤栏，顶部高度为 61
        setContentHeight(
          window.innerHeight
          - 61
          - appHeight
          - 1,
        );
      }
      // setlineDisplay('block');
    }

    // 设置标线状态
    if (pathPartList.some((item) => item === 'steptwo')) {
      setisHome(true);
      // 规避第一次进入homepage页面的时候3D图没渲染完成导致画标线报错
      if (!isFirstintoHome) {
        callEngine(initState.engine3D, 'calloutLine', true, undefined);
        dispatch({ type: 'sizeMark', payload: true });
      }
      setisFirstintoHome(false);
    } else if (pathPartList.some((item) => item === 'stepthree')) { // step3需要显示标线？
      setisHome(false);
      dispatch({ type: 'sizeMark', payload: true });
    } else if (pathPartList.some((item) => item === 'doorPlank')) {
      if (initState.isFirstintoDoor) { // 只有第一次进入门板页面才需要取消标线
        // setisFirstintoDoor(false);
        dispatch({ type: 'isFirstintoDoor', payload: false });
        callEngine(initState.engine3D, 'calloutLine', false, undefined);
        dispatch({ type: 'otherMark', payload: false });
      } else { // 当不是第一次时标线需要同步跟initState.otherMaerk，因为标线状态会被homePage页面影响
        callEngine(initState.engine3D, 'calloutLine', initState.otherMark, undefined);
      }

      setisHome(false);
    } else {
      setisHome(false);
    }
  }, [pathname]);

  // 监听isJump,当页面跳转时设置scrollTop=0
  useEffect(() => {
    if (initState.isJump) {
      container.current.scrollTop = 0;
    }
    dispatch({ type: 'isJump', payload: false });
  }, [initState.isJump]);

  // 显示navbar
  const showNavbar = () => {
    const navLength = initState.titleList.filter((i) => i.title === initState.currentTitle);
    const platform = localStorage.getItem('platform');
    console.log('tgr platform', platform, localStorage.getItem('gioPlatform'));
    if (navLength.length > 0 && platform !== 'smp') {
      return <NavBar title={initState.currentTitle} />;
    } return null;
  };

  const renderBox = useCallback(() => ( // 3D渲染区组件
    <RenderBox
      width={appWidth}
      height={appHeight}
      calloutLines={initState.calloutline}
      show
      showLoading={initState.showLoading}
      initCallBack={({ engine }) => {
        dispatch({ type: 'engine-change', payload: engine });
      }}
    />
  ), [appWidth, appHeight, initState.calloutline, initState.showLoading]);

  const eventHandle = () => { // 事件处理函数
    if (initState.filterColor) {
      dispatch({ type: 'filterColor', payload: false });
    }
    if (initState.istip) {
      dispatch({ type: 'istip', payload: false });
    }
  };
  const eventHandleMove = () => {
    if (initState.isChangeTopTips) {
      dispatch({ type: 'isChangeTopTips', payload: false });
    }
  };
  // 是否展示canvas
  const showCanvas = () => (!!((pathname === '/home/homepage/steptwo' || pathname === '/home/homepage/stepthree'
        || pathname.includes('/home/doorPlank') || pathname === '/home/mesa' || pathname.includes('/home/storage')
        || (pathname.includes('change') && !pathname.includes('stepone')))) && !pathname.includes('assembly')
        && !pathname.includes('payService'));

  // 显示3D渲染图
  const showRenderBox = () => {
    if (!showCanvas()) {
      callEngine(initState.engine3D, 'stopRender', undefined, initState.jsonTemplate);
    } else {
      callEngine(initState.engine3D, 'startRender', undefined, initState.jsonTemplate);
    }

    return (
      <div
        style={{

          display: 'block',
          backgroundColor: '#F5F5F5',
          position: showCanvas() ? 'relative' : 'absolute',
          visibility: showCanvas() ? 'visible' : 'hidden',
        }}
        aria-hidden
        onTouchMove={eventHandle}
      >
        {/* <RenderBox
        width={appWidth}
        height={appHeight}
        calloutLines={initState.calloutline}
        show
        showLoading={initState.showLoading}
        initCallBack={({ engine }) => {
          dispatch({ type: 'engine-change', payload: engine });
        }}
      /> */}
        {renderBox()}
        <SideBar pathname={pathname} isHome={isHome} floorList={floorList} wallList={wallList} />
        <div
          className={style.gestureTip}
          style={{
            width: `${imgWidht}px`,
            height: `${imgHeight}px`,
            left: `${gestureX - (imgWidht / 2)}px`,
            top: `${gestureY}px`,
            display: initState.istip ? 'block' : 'none',
          }}
        >
          <img
            className={style.img}
            style={{ width: `${imgWidht}px`, height: `${imgHeight}px` }}
            src={gestureTip}
            alt=""
          />
        </div>
      </div>
    );
  };

  const [sketchType, setsketchType] = useState('LIR');
  const sketchList = [
    { id: 'LIR', src: sketchLIR },
    { id: 'LIL', src: sketchLIL },
    { id: 'LLR', src: sketchLL },
    { id: 'LNR', src: sketchLN },
    { id: 'IIR', src: sketchII },
    { id: 'INR', src: sketchIN },
    { id: 'UHR', src: sketchUH },
    { id: 'UIR', src: sketchUIR },
    { id: 'UIM', src: sketchUIM },
    { id: 'UIL', src: sketchUIL },
    { id: 'ULR', src: sketchULR },
    { id: 'ULL', src: sketchULL },
    { id: 'UNR', src: sketchUN },
    { id: 'HHR', src: sketchHH },
    { id: 'HIR', src: sketchHIR },
    { id: 'HIL', src: sketchHIL },
    { id: 'HNR', src: sketchHN },
  ];

  useEffect(() => {
    const newSketch = `${initState.sizeUnder.key}${initState.sizeTop.key}${initState.isSeat}`;
    // 避免同时切换底柜和顶柜时，出现HL和LH的异常情况
    if (newSketch !== sketchType && sketchList.find((item) => item.id === newSketch)) {
      setsketchType(newSketch);
      if (pathname.includes('/stepone')) {
        const timer = setInterval(() => {
          if (document.getElementById('sketch').complete) {
            Loading.hide();
            clearInterval(timer);
          }
        }, 100);
      }
    }
  }, [initState.sizeUnder, initState.sizeTop, initState.isSeat]);

  return (
    <>
      <div id="bars-container">
        {showNavbar()}
      </div>

      {/* stepone 显示示意图 */}
      {
        pathname.includes('/stepone') ? (
          <div
            className={style.sketchBox}
            style={{
              width: `${appWidth}px`,
              height: `${sketchHeight}px`,
            }}
          >
            <img
              id="sketch"
              className={style.sketch}
              src={sketchList.find((item) => item.id === sketchType).src}
              alt=""
            />
          </div>
        ) : null
      }

      {showRenderBox()}
      <div
        className={style['card-container']}
        // stepone时relative能避免steptwo返回时3d渲染图隐藏瞬间图层错乱
        style={{ position: pathname.includes('/stepone') ? 'relative' : 'unset' }}
      >
        <div
          style={{ height: isPackOffer ? 0 : contentHeight, overflow: initState.isShowFilter ? 'hidden' : 'auto' }}
          className={style.container}
          id="content-container"
          ref={container}
          aria-hidden
          onScroll={eventHandle}
          onTouchMove={eventHandleMove}
        >
          {targetRouter()}

        </div>
      </div>
      {
        // (PLATFORM() === 'smp' || sessionStorage.getItem('referrer') || storeLeadsInfo()?.source === 'leads') && (
        //   <div
        //     className={style['back-home']}
        //     role="none"
        //     style={{ width: exitWidth }}
        //   >
        //     <span className={style['back-arrow']} role="none" onClick={handleClickHideExit}>
        //       <img
        //         className={exitWidth === '2.5rem' ? style['back-hide-arrow'] : style['back-show-arrow']}
        //         src={ArrowDownImg}
        //         alt=""
        //         role="none"
        //         onClick={handleClickHideExit}
        //       />
        //     </span>
        //     <span
        //       role="none"
        //       onClick={handleClickExitBtn}
        //       className={style['back-home-word']}
        //       style={{ display: exitWidth === '2.5rem' && 'none' }}
        //     >
        //       {t('exit_design')}
        //     </span>
        //   </div>
        // )
      }
      <AidDialog
        visible={visible}
        onCancel={handleCancel}
        onOk={handleOk}
        ButtonCount={1}
        width={17.75}
        height={20.625}
        btnStyle={{
          okBtnName: '',
          cancelBtnName: t('cancel'),
          btnWidth: 160,
          btnHeight: 52,
          centerWidth: '10px',
          backgroundColor: ['#0058b3'],
          BtnMarginBottom: '30px',
        }}
      >
        <ArcButton
          position="absolute"
          top={-60}
          backgroundColor="rgb(255, 255, 255, 0.2)"
          width={9.875}
          height={2.5}
          margin="auto"
          text={t('other.click_dark_area_close_the_poster')}
          handleChecked={handleCancel}
        />
        <div className={style['dialog-child']}>
          <h2>{t('navBar.noDesign')}</h2>
          <p className={style['title-text']}>{t('navBar.exclusiveService')}</p>
          <img className={style.groupImg} src={group} alt="" />
        </div>
        <ArcButton
          backgroundColor="#ffffff"
          margin="auto"
          width={15}
          height={3.125}
          text={t('navBar.designer')}
          handleChecked={contactDesigner}
        />
        <p
          style={{ textAlign: 'center', color: '#ffffff', marginTop: '1rem' }}
          role="presentation"
          onClick={() => handleClose(initState)}
        >
          {t('navBar.directlyOut')}
        </p>
      </AidDialog>
    </>
  );
}

HomePage.propTypes = {
  location: propTypes.shape({
    pathname: propTypes.string,
    state: propTypes.string,
  }).isRequired,
  history: propTypes.shape({
    push: propTypes.func,
  }).isRequired,
};

export default withRouter(HomePage);
